import { capitalize } from '@utils/strings.util';
import { EventType } from './HeroSection.types';

export const getEvenType = (eventType: string) => {
  return capitalize(eventType.replace(/([A-Z])/g, ' $1').trim());
};

export const joyAllEventTypes: EventType[] = Object.values(EventType);

export const joyEventTypes: EventType[] = Object.values(EventType).filter(type => type !== EventType.general);

export const getEventTypesForQuery = () => {
  return [EventType.general, EventType.babyRegistry, EventType.wedding];
};

// export const joyEventTypes: string[] = Object.keys(EventType)
//   .filter(type => type !== EventType.general)
//   .map(type => getEvenType(type));
